import React from 'react';
import ReactTable from 'react-table';
import { t } from '../../../../../modules/infra/i18n';

import EmptyList from './EmptyList';
import * as shapes from '../shapes';
import * as commonShapes from '../../../../common/shapes';
import withLoadingList from '../../../../common/hoc/withLoaingList';
import { canUserModifyTaxes } from '../../../../common/helpers/users';
import getColumns from './columns';

const getDefaultColumns = (tFunc) => {
  const columnsDefinition = getColumns(tFunc);
  return [
    columnsDefinition.name,
    columnsDefinition.percentage,
    columnsDefinition.addToPrice,
    columnsDefinition.externalOrdersOnly,
    columnsDefinition.enabled,
  ];
};

const TaxesTable = (props) => {
  const { permissions, onEditTax } = props;
  const isAbleToModify = canUserModifyTaxes(permissions);
  let { taxes } = props;
  if (props.barberUser) {
    taxes = props.taxes.filter((tax) => tax.ownerType === 'barber' && tax.ownerId === props.barberUser.id);
  }

  const columns = props.columns || getDefaultColumns(t);

  return (
    <ReactTable
      className="c-table-card c-table-new u-table-layout-fixed u-mt c-no-hover-border c-overflow-visible"
      minRows={0}
      showPagination={false}
      defaultPageSize={Number.MAX_SAFE_INTEGER}
      data={taxes}
      columns={columns}
      getTrProps={(_, row) => ({
        className: isAbleToModify ? 'u-cursor-pointer' : '',
        onClick: () => isAbleToModify && onEditTax(row.original.id),
      })}
    />
  );
};

TaxesTable.propTypes = {
  columns: ReactTable.propTypes.columns,
  taxes: shapes.taxes.isRequired,
  permissions: commonShapes.permissions.isRequired,
  onEditTax: shapes.handler,
};

TaxesTable.defaultProps = {
  columns: undefined,
  onEditTax: () => {},
};

export default withLoadingList((props) => props.taxes, EmptyList)(TaxesTable);
